import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Alert,
    IconButton,
    Tooltip,
    Box,
} from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { Payment } from '../../../models/Payment';
import { formatCurrency } from '../../../utils/formatters';

interface PaymentListProps {
    payments: Payment[];
    loading: boolean;
    error: string | null;
    onRefresh: () => void;
}

const PaymentList: React.FC<PaymentListProps> = ({
    payments,
    loading,
    error,
    onRefresh,
}) => {
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Alert severity="error" action={
                <IconButton
                    aria-label="refresh"
                    color="inherit"
                    size="small"
                    onClick={onRefresh}
                >
                    <RefreshIcon />
                </IconButton>
            }>
                {error}
            </Alert>
        );
    }

    return (
        <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Order ID</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Cost</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Type</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payments.map((payment) => (
                        <TableRow key={payment.id}>
                            <TableCell>
                                {payment.dueDate ? payment.dueDate.toLocaleDateString() : '-'}
                            </TableCell>
                            <TableCell>{payment.orderId || '-'}</TableCell>
                            <TableCell>{formatCurrency(payment.amount)}</TableCell>
                            <TableCell>{formatCurrency(payment.cost)}</TableCell>
                            <TableCell>{payment.status}</TableCell>
                            <TableCell>{payment.type}</TableCell>
                        </TableRow>
                    ))}
                    {payments.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={6} align="center">
                                No payments found
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PaymentList; 